<template>
  <div class="statistics">
    <LockPage v-show="isLockPage" @change-view="showLogView"></LockPage>
    <LogPage v-if="!isLockPage" :equip-code="showEquipCode" :room-name="roomName" :room-code="roomCode" @change-view="hideLogView"></LogPage>
  </div>
</template>

<script>
import LogPage from './logPage'
import LockPage from './lockPage'

export default {
  name: 'equipDoorlockMain',
  components: { LogPage, LockPage },
  data() {
    return {
      isLockPage: true,
      roomName: '',
      roomCode: '',
      showEquipId: '',
      showEquipCode: ''
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$eventBus.off('change-shop')
    next()
  },
  created() {
    this.$eventBus.on('change-shop', () => {
      if (!this.isLockPage) {
        this.hideLogView()
      }
    })
  },
  mounted() {
    let curLockPageShowId = localStorage.getItem('curLockPageShowId')
    let curLockPageCodeId = localStorage.getItem('curLockPageCodeId')
    if (curLockPageShowId && curLockPageCodeId) {
      this.$nextTick(() => {
        this.showEquipId = curLockPageShowId
        this.showEquipCode = curLockPageCodeId

        this.isLockPage = false
      })
    }
  },
  methods: {
    // 隐藏门锁页，备份门锁页分页信息
    showLogView(row) {
      this.bakePagination()

      localStorage.setItem('curLockPageShowId', row.id)
      localStorage.setItem('curLockPageCodeId', row.deviceCode)
      localStorage.removeItem('curUrlPageSize')
      localStorage.removeItem('curUrlPageIndex')
      this.showEquipId = row.id
      this.roomName = row.roomName
      this.roomCode = row.roomCode;
      this.showEquipCode = row.deviceCode
      this.isLockPage = false
    },
    // 隐藏日志页，恢复门锁页分页信息，销毁日志页信息
    hideLogView() {
      localStorage.setItem('curUrlPageSize', this.bakePageSize || 10)
      localStorage.setItem('curUrlPageIndex', this.bakePageIndex || 1)
      localStorage.removeItem('curLockPageShowId')
      localStorage.removeItem('curLockPageCodeId')

      this.isLockPage = true
    },
    // 备份门锁页分页信息
    bakePagination() {
      this.bakePageSize = localStorage.getItem('curUrlPageSize')
      this.bakePageIndex = localStorage.getItem('curUrlPageIndex')
    },
    // 备份日志页分页信息
    backLogPagination() {
      this.bakeLogPageSize = localStorage.getItem('curUrlPageSize')
      this.bakeLogPageIndex = localStorage.getItem('curUrlPageIndex')
    }
  },
}
</script>
